export default "__VITE_ASSET__CYk6RizZ__"